import { components } from "@certn/api/generated-schemas/applicant-portal";
import { Link } from "@certn/cascadia-react";
import { formatDate } from "@certn/utils";
import { Trans, useTranslation } from "react-i18next";

import { BaseCard } from "./BaseCard";
import { buildSubmittedTimelineSteps } from "./submittedTimeline";

interface Props {
  caseInstance: components["schemas"]["CompleteCaseList"];
}
export function SubmittedCard(props: Props) {
  const { caseInstance } = props;
  const { t } = useTranslation();

  const submittedDate = caseInstance.logs?.findLast(
    ({ additional_data }) => additional_data?.event === "APPLICANT_SUBMITTED"
  )?.timestamp;

  const progressSteps = buildSubmittedTimelineSteps(caseInstance, t);

  const statusText = (
    <>
      <Trans>Submitted</Trans> {formatDate(submittedDate ?? "", "PP")}
      {!caseInstance.restrict_applicant_communications && (
        <>
          {" "}
          -{" "}
          <Link
            linkStyle="monochrome"
            testID="view-report-link"
            href={`/report/${caseInstance.short_id}/`}
          >
            <Trans>View Report</Trans>
          </Link>
        </>
      )}
    </>
  );

  return (
    <BaseCard
      title={caseInstance.customer_name}
      type="processing"
      tagText={t("Processing")}
      statusText={statusText}
      progressSteps={progressSteps}
      variant="historyCard"
      shortID={caseInstance.short_id}
    />
  );
}
